import $ from "jquery";
import Swiper, {Pagination} from "swiper";

export default function onResizeWindow() {


    window.addEventListener("resize", function (e) {
        //======================================================================================================
        // Pagination Themenverwandt wird nach Bottom des Container in der Mobile Ansicht dargestellt
        //======================================================================================================
        if(window.innerWidth <= 992) {
            $(".item-link-active").addClass("show");

            /*if ($(".theme-parent .swiper-buttons-container > .swiper-buttons-pagination-container > .swiper-buttons > .theme-parent-pagination").length == 0) {
                $(".theme-parent .swiper-button-prev").after($(".theme-parent-pagination"));
            }*/
            if ($(".open-dropdown-menu-level-0").hasClass("resized_with_open_menu")) {
                $(".open-dropdown-menu-level-0").removeClass("resized_with_open_menu");
            }
            $(".review-module").attr("aria-hidden","true");
            $(".menu-desktop").attr("aria-hidden","true");
            $(".menu-mobile").attr("aria-hidden","false");
            $(".sticky-element-termin-desktop").attr("aria-hidden","true");
            $(".sticky-element-termin-mobile").attr("aria-hidden","false");
            if ($(".swiper-container-mobile > .reviews.reviews-swiper.swiper").length == 0) {
                $( ".swiper-container-mobile" ).append( $( ".reviews.reviews-swiper.swiper" ));
            }
            if ($(".swiper-container-pagination-mobile > .reviews-pagination-buttons").length == 0) {
                $( ".swiper-container-pagination-mobile" ).append( $( ".reviews-pagination-buttons" ));
                /*if ($(".reviews-pagination-elements > .swiper-pagination").length == 0) {
                    $( ".reviews-pagination-elements" ).append($( ".swiper-pagination" ));
                    $( ".swiper-button-next-review" ).before($( ".swiper-pagination" ));
                }*/
            }
            if ($(".review-module-title-mobile > .review-module-title-content").length == 0) {
                $(".review-module-title-mobile").append($(".review-module-title-content"));
            }
            //$(".menu-item-has-children > .nav-link > .post-title").addClass("add-after");


        }
        if(window.innerWidth > 992) {
            let currentImageActive = $(".gallery-swiper >.swiper-wrapper > .swiper-slide:first-child .swiper-item-link-active");
            let anyImageActive = $(".gallery-swiper >.swiper-wrapper > .swiper-slide .swiper-item-link-active.show-bar").length;
            if(currentImageActive.hasClass("show-bar") == false && anyImageActive == 0) {
                currentImageActive.addClass("show-bar");
            }

            $(".review-module").attr("aria-hidden","false");
            $(".menu-desktop").attr("aria-hidden","false");
            $(".menu-mobile").attr("aria-hidden","true");
            $(".sticky-element-termin-desktop").attr("aria-hidden","false");
            $(".sticky-element-termin-mobile").attr("aria-hidden","true");
            /*if ($(".theme-parent .swiper-buttons-container > .swiper-buttons-pagination-container > .swiper-buttons > .theme-parent-pagination").length >= 1) {
                $(".theme-parent .theme-parent-text").after($(".theme-parent-pagination"));
            }*/
            if ($(".review-module .overlapping-text-container .overlapping-text > .reviews.reviews-swiper.swiper").length == 0) {
                $( ".review-module .overlapping-text-container .overlapping-text").prepend($( ".reviews.reviews-swiper.swiper" ));
            }

            if ($(".reviews-pagination-container > .reviews-pagination-buttons").length == 0) {
                $( ".reviews-pagination-container").prepend($( ".reviews-pagination-buttons" ));
                /*if ($(".reviews-pagination-buttons > .swiper-pagination:first-child").length == 0) {
                    $( ".reviews-pagination-buttons").prepend($( ".swiper-pagination" ));
                }*/
            }
            if ($(".review-module-title-desktop > .review-module-title-content").length == 0) {
                $(".review-module-title-desktop").append($(".review-module-title-content"));
            }

            $(".gallery-photo-viewer img").css("opacity","1");
            if(window.innerHeight > 900) {
              $(".open-dropdown-menu-level-0").addClass("resized_with_open_menu");
            }
            if($(".item-link-active").hasClass("show")) {
                $(".item-link-active").removeClass("show");
            }
            let galleryImageActive = $(".swiper-item-link-active.show-bar");
            if(galleryImageActive.length == 0) {
                let imageActive = $(".image-swiper-slide#1");
                imageActive.prev().addClass("show-bar");
            }

        }
    });

}